import { Entity } from '@api/api/entity-schema';
import { TabPanel } from '@design/components/tab-panel/TabPanel';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import { useTranslation } from 'react-i18next';

import { GeographicExposureDrawer } from './drawers/GeographicExposureDrawer';
import styles from './GeographicExposureTab.module.scss';
import { CountryExposureTab } from './tabs/CountryExposureTab';
import { RegionalExposureTab } from './tabs/RegionalExposureTab';

const GeoTabs = {
  Country: 'country',
  Regional: 'regional',
};

export interface GeographicExposureTabProps {
  entity: Entity;
}

export const GeographicExposureTab = ({
  entity,
}: GeographicExposureTabProps) => {
  const { t } = useTranslation(['widget']);
  const { params, setQueryParams } = useQueryParams();
  const requestedTab = params[queryKeys.geoSubTab];
  const activeTab =
    requestedTab === GeoTabs.Regional ? GeoTabs.Regional : GeoTabs.Country;

  const TAB_LABELS = [
    t('widget:assetOverview.knowledgeGraph.geographicExposure.countryExposure'),
    t('widget:assetOverview.knowledgeGraph.geographicExposure.regionExposure'),
  ];

  return (
    <div className={styles.root} data-testid="geographic-exposure-tab">
      <TabPanel
        className={styles.styledTabPanel}
        tabs={[
          {
            tabKey: GeoTabs.Country,
            tabLabel: TAB_LABELS[0],
            renderPanel: <CountryExposureTab entityTag={entity.tag} />,
          },
          {
            tabKey: GeoTabs.Regional,
            tabLabel: TAB_LABELS[1],
            renderPanel: <RegionalExposureTab entityTag={entity.tag} />,
          },
        ]}
        activeTab={activeTab}
        onChange={(_, tabKey) =>
          setQueryParams({ [queryKeys.geoSubTab]: tabKey })
        }
      />

      <GeographicExposureDrawer entity={entity} />
    </div>
  );
};
